import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/config";

export const WhyWeRun = () => (
  <section id="why" data-testid="why-section" className="relative bg-hope-cream py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-16 px-4 md:px-8 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Reveal>
          <p data-testid="why-overline" className="mb-8 text-sm font-semibold uppercase tracking-[0.3em] text-hope-green">
            Why We Run
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2
            data-testid="why-manifesto"
            className="font-heading text-3xl font-bold leading-[1.25] tracking-tight text-hope-ink sm:text-4xl md:text-[2.75rem]"
          >
            In recognition of{" "}
            <span className="text-hope-green">
              National Hunger &amp; Homelessness Awareness Week
            </span>
            , every registration and every step helps Hope Restored Missions
            expand{" "}
            <span className="text-hope-red">capital resources</span> and{" "}
            <span className="text-hope-red">transitional housing</span> for
            individuals and families in crisis.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-zinc-600 md:text-lg">
            Right here in our community, neighbors are one setback away from
            losing everything. Hope Restored Missions walks with them from
            crisis to stability — and on November 21, we run so they don't
            have to walk alone.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 grid max-w-xl grid-cols-2 gap-8 border-t border-black/10 pt-8">
            <div data-testid="why-stat-1">
              <p className="font-heading text-4xl font-black text-hope-green md:text-5xl">100%</p>
              <p className="mt-2 text-sm text-zinc-600">
                of net proceeds fund housing &amp; crisis resources
              </p>
            </div>
            <div data-testid="why-stat-2">
              <p className="font-heading text-4xl font-black text-hope-green md:text-5xl">3.13<span className="text-2xl">mi</span></p>
              <p className="mt-2 text-sm text-zinc-600">
                certified, chip-timed 5K course at Celebration Park
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="relative lg:col-span-5">
        <Reveal delay={0.15} className="relative h-full">
          <div className="absolute -left-4 -top-4 h-full w-full rounded-3xl border-2 border-hope-green/40" />
          <img
            src={IMAGES.hands}
            alt="Hands holding a heart — the people Hope Restored Missions serves"
            data-testid="why-image"
            className="relative h-full min-h-[420px] w-full rounded-3xl object-cover shadow-md"
          />
          <div className="absolute -bottom-6 -right-4 rounded-2xl bg-hope-ink px-6 py-5 text-white shadow-lg md:-right-8">
            <p className="font-heading text-lg font-bold leading-snug">
              Every step restores hope.
            </p>
            <p className="mt-1 text-xs uppercase tracking-[0.2em] text-hope-bright">
              Allen, Texas
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
